<template>
  <div id="my_basic_information" class="my_basic_information_top">
    <van-col span="22" offset="1" v-if="is_vip">
      <!-- 体型 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.shape" :label="$t('user.shape')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 有无子女 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.children" :label="$t('user.children')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 血型 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.blood_type" :label="$t('user.blood_type')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 出生地 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.birthplace" :label="$t('user.birthplace')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 吸烟情况 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.Smoking" :label="$t('user.Smoking')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 饮酒情况 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.drinking_situation" :label="$t('user.drinking_situation')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 兄弟姐妹 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.brothers_sisters" :label="$t('user.brothers_sisters')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 国籍-->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.nationality" :label="$t('user.nationality')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 语言-->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.language" :label="$t('user.language')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 性格-->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.character" :label="$t('user.character')" readonly />
        </van-cell-group>
      </van-col>

      <!-- 毕业院校 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.school" :label="$t('user.school')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 对结婚的要求 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.requirements_marriage" :label="$t('user.requirements_marriage')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 要不要小孩 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.want_children" :label="$t('user.want_children')" readonly />
        </van-cell-group>
      </van-col>
      <!--  交友状态  -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.friendship_status" :label="$t('user.friendship_status')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 约会费用 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.appointment_fee" :label="$t('user.appointment_fee')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 居住情况 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.living_conditions" :label="$t('user.living_conditions')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 休息日 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.rest_day" :label="$t('user.rest_day')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 社交性 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.sociality" :label="$t('user.sociality')" readonly />
        </van-cell-group>
      </van-col>
      <!-- 兴趣爱好 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.hobby" :label="$t('user.hobby')" readonly />
        </van-cell-group>
      </van-col>
    </van-col>
  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import { judgeIosAndroid } from '@/assets/js/models.js'
  import axios from 'axios'
  import { Toast, Uploader, Collapse, CollapseItem } from 'vant'
  export default {
    data() {
      return {
        is_vip: false,
        user: {
          "user_nickname":"",  // 用户昵称
          "avatar":"",       // 用户头像
          "height":'',       // 身高
          "age":'',          // 年龄
          "diploma":"",      // 学历
          "marriage":"",      // 婚姻状况
          "monthly_income":"", // 月收入
          "professional":"",  // 职业
          "signature":"",   // 交友心声
          "province" :'',   // 省
          "city" :'',        // 市
          "children":'',  // 有无子女
          "shape" : '', // 体型
          "blood_type":"",  // 血型
          "birthplace":"",       // 出生地
          "Smoking":'',       // 吸烟情况
          "drinking_situation":'',          // 饮酒情况
          "brothers_sisters":"",      // 兄弟姐妹
          "nationality":"",      // 国籍
          "language":"",     // 语言 多个用逗号隔开
          "school":"",      // 毕业院校
          "requirements_marriage":"",   // 对结婚要求
          "want_children" :'',   // 要不要小孩
          "friendship_status" :'',        // 交友状态
          "appointment_fee":'',  // 约会费用
          "character" : '', // 性格，多个用逗号隔开
          "living_conditions" : '', // 居住情况
          "rest_day" : '', // 休息日
          "sociality" : '', // 社交性
          "hobby" : '', // 兴趣爱好
        }
      };
    },
    created: function() {
      this.convert()
      document.title = this.$t('title.more_information')
    },
    methods: {
      convert: function() {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        const touid = this.$route.query.touid
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/vue_touser_information", {
          params: {
            uid: uid,
            token: token,
            touid: touid
          }
        }).then(res => {
          if(res.data.code == 1){
            this.is_vip = res.data.is_vip ? true : false
            this.user = res.data.data
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/more_information.vue